(function (global) {
  'use strict';

  // Filter actual variants by the preceding option choices. Never build a Cartesian product.
  function optionRows(variants, index, prefix) {
    const matches = variants.filter(variant => prefix.every((value, position) => variant.options[position] === value));
    const values = [...new Set(matches.map(variant => variant.options[index]))].filter(value => value != null);
    return values.map(value => ({
      value,
      available: matches.some(variant => variant.options[index] === value && variant.available)
    }));
  }

  function chooseVariant(variants, requestedOptions) {
    if (!variants.length) return null;
    const prefix = [];
    const count = variants[0].options.length;
    for (let index = 0; index < count; index += 1) {
      const rows = optionRows(variants, index, prefix);
      const preferred = rows.find(row => row.value === requestedOptions[index]);
      const row = preferred || rows.find(candidate => candidate.available) || rows[0];
      if (!row) return null;
      prefix.push(row.value);
    }
    return variants.find(variant => prefix.every((value, index) => variant.options[index] === value)) || null;
  }

  function validQuantity(value, rule) {
    const quantity = Number(value);
    const minimum = Number(rule?.min) || 1;
    const increment = Number(rule?.increment) || 1;
    const maximum = rule?.max == null ? null : Number(rule.max);
    return Number.isSafeInteger(quantity) && quantity >= minimum && (quantity - minimum) % increment === 0 && (maximum == null || quantity <= maximum);
  }

  const api = { optionRows, chooseVariant, validQuantity };
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }
  if (global.OnaShadeUI) {
    global.OnaShadeUI.mount(document);
    return;
  }

  function initialize(root) {
    if (root.dataset.shadeInitialized) return;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const dataElement = $('[data-shade-data]');
    let data;
    try { data = JSON.parse(dataElement.textContent); } catch (_) { return; }
    const variants = data.variants;
    if (!Array.isArray(variants) || !variants.length) return;
    const nativeSelect = $('[data-shade-variant]');
    const form = $('[data-shade-form]');
    const selectors = $$('[data-shade-option]');
    const quantity = $('[data-shade-quantity]');
    const add = $('[data-shade-add]');
    if (!nativeSelect || !form || !quantity || !add) return;
    root.dataset.shadeInitialized = 'true';
    const base = data.root.endsWith('/') ? data.root : data.root + '/';
    const addLabel = data.add_label || 'Add shade to bag';
    let current = variants.find(variant => String(variant.id) === nativeSelect.value) || variants.find(variant => variant.available) || variants[0];
    let busy = false;

    function setError(message) {
      $('[data-shade-error]').textContent = message;
      $('[data-shade-error-box]').hidden = !message;
    }

    function showMedia(id) {
      const panes = $$('[data-shade-media]');
      const requested = panes.find(pane => pane.dataset.shadeMedia === String(id));
      const chosen = requested || panes.find(pane => pane.dataset.shadeMedia === String(data.default_media_id)) || panes[0];
      if (!chosen) return;
      panes.forEach(pane => {
        const active = pane === chosen;
        pane.hidden = !active;
        if (!active) {
          pane.querySelectorAll('video').forEach(video => video.pause());
          pane.querySelectorAll('iframe').forEach(frame => {
            try {
              const origin = new URL(frame.src).origin;
              if (origin.includes('youtube.com') || origin.includes('youtube-nocookie.com')) frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), origin);
              if (origin === 'https://player.vimeo.com') frame.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), origin);
            } catch (_) { /* A non-video frame does not need a pause command. */ }
          });
        }
      });
      $$('[data-shade-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.shadeThumbnail === chosen.dataset.shadeMedia)));
    }

    function updateQuantityRule() {
      const rule = current.quantity_rule || {};
      const minimum = Number(rule.min) || 1;
      const increment = Number(rule.increment) || 1;
      quantity.min = minimum;
      quantity.step = increment;
      if (rule.max != null) quantity.max = Number(rule.max);
      else quantity.removeAttribute('max');
      if (!validQuantity(quantity.value, rule)) quantity.value = minimum;
      quantity.removeAttribute('aria-invalid');
      const notes = [];
      if (minimum > 1) notes.push('Minimum ' + minimum + '.');
      if (increment > 1) notes.push('Order in increments of ' + increment + '.');
      if (rule.max != null) notes.push('Maximum ' + rule.max + ' per order.');
      $('[data-shade-quantity-note]').textContent = notes.join(' ');
    }

    const colorControls = $$('[data-standard-shade-color]');
    const colorSelect = selectors[0];
    const sizeSelect = selectors[1];
    const dimensions = variant => (variant.options[1] || '').match(/\d+(?:\.\d+)?/g)?.slice(0, 2).map(Number);
    const splitDimensions = sizeSelect && variants.every(variant => dimensions(variant)?.length === 2);
    const dimensionSelects = [];
    if (splitDimensions) {
      sizeSelect.closest('.os-option').hidden = true;
      ['Width', data.family === 'curtain' ? 'Length' : 'Height'].forEach((label, index) => {
        const field = document.createElement('div'); field.className = 'os-option';
        const name = document.createElement('label'); const select = document.createElement('select');
        select.id = 'StandardDimension-' + root.dataset.sectionId + '-' + index;
        name.htmlFor = select.id; name.textContent = label;
        field.append(name, select); $('[data-shade-picker]').append(field);dimensionSelects.push(select);
        select.addEventListener('change', () => {
          const rows = variants.filter(variant => variant.options[0] === current.options[0]);
          const requested = dimensionSelects.map(control => Number(control.value));
          const exact = rows.find(variant => dimensions(variant).every((value, position) => value === requested[position]));
          const fallback = rows.filter(variant => dimensions(variant)[index] === requested[index]);
          display(exact || fallback.find(variant => variant.available) || fallback[0], true);
        });
      });
    }
    function updateTotal() {
      const count = Math.max(1, Number(quantity.value) || 1);
      const total = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:data.currency || 'USD'}).format(current.price * count / 100);
      $('[data-shade-price]').textContent = total;
    const compareEl = $('[data-shade-compare]');
    if (compareEl) {
      const was = current.compare_at_price;
      if (was && was > current.price) {
        compareEl.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:data.currency || 'USD'}).format(was * count / 100);
        compareEl.hidden = false;
      } else { compareEl.textContent = ''; compareEl.hidden = true; }
    }
      const packEl = $('[data-standard-pack]');
      if (packEl) {
        const u = data.unit_label;
        packEl.textContent = u === 'pair' ? (count * 2) + ' panels'
          : u === 'panel' ? count + (count === 1 ? ' panel' : ' panels')
          : u === 'set' ? count + (count === 1 ? ' set' : ' sets')
          : count + (count === 1 ? ' shade' : ' shades');
      }
    }
    colorControls.forEach(radio => radio.addEventListener('change', () => {
      const options = current.options.slice(); options[0] = radio.value;
      display(chooseVariant(variants, options), true);
    }));
    function renderOptions() {
      selectors.forEach((select, index) => {
        const rows = optionRows(variants, index, current.options.slice(0, index));
        select.replaceChildren();
        rows.forEach(row => {
          const option = document.createElement('option');
          option.value = row.value;
          option.textContent = row.value + (row.available ? '' : ' — Sold out');
          select.append(option);
        });
        select.value = current.options[index];
      });
      colorControls.forEach(radio => {radio.checked=radio.value===current.options[0];radio.disabled=busy;});
      $('[data-standard-color]').textContent=current.options[0];
      if (splitDimensions) dimensionSelects.forEach((select,index) => {
        const rows=variants.filter(variant=>variant.options[0]===current.options[0]);
        const prefix=index===0?rows:rows.filter(variant=>dimensions(variant)[0]===dimensions(current)[0]);
        const values=[...new Set(prefix.map(variant=>dimensions(variant)[index]))].sort((a,b)=>a-b);
        select.replaceChildren();
        values.forEach(value=>{const option=document.createElement('option');option.value=String(value);option.textContent=value+'″';const matching=prefix.filter(variant=>dimensions(variant)[index]===value);if(!matching.some(variant=>variant.available))option.textContent+=' — Sold out';select.append(option);});
        select.value=String(dimensions(current)[index]);
      });
    }

    function display(variant, replaceURL) {
      if (!variant) return;
      current = variant;
      nativeSelect.value = String(variant.id);
      renderOptions();
      updateQuantityRule();
      const label = variant.title === 'Default Title' ? 'One ' + (data.unit_label || 'shade') : variant.title;
      updateTotal();
      $('[data-shade-selection]').textContent = label + (variant.available ? '' : ' · Currently sold out');
      $('[data-shade-selection]').dataset.available = String(variant.available);
      $('[data-shade-detail-selection]').textContent = label;
      $('[data-shade-size-selection]').textContent = label;
      add.disabled = busy || !variant.available;
      $('[data-standard-checkout]').disabled=busy || !variant.available;
      add.textContent = variant.available ? addLabel : 'Currently sold out';
      showMedia(variant.media_id);
      setError('');
      if (replaceURL) {
        const url = new URL(global.location.href);
        url.searchParams.set('variant', String(variant.id));
        global.history.replaceState({}, '', url);
      }
    }

    selectors.forEach((select, index) => select.addEventListener('change', () => {
      const options = current.options.slice();
      options[index] = select.value;
      display(chooseVariant(variants, options), true);
    }));
    $$('[data-shade-thumbnail]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.shadeThumbnail)));
    quantity.addEventListener('input', () => {
      quantity.removeAttribute('aria-invalid');
      updateTotal();
      if (validQuantity(quantity.value, current.quantity_rule)) updateQuantityNote();
    });
    function updateQuantityNote() {
      const rule = current.quantity_rule || {};
      const notes = [];
      if (Number(rule.min) > 1) notes.push('Minimum ' + rule.min + '.');
      if (Number(rule.increment) > 1) notes.push('Order in increments of ' + rule.increment + '.');
      if (rule.max != null) notes.push('Maximum ' + rule.max + ' per order.');
      $('[data-shade-quantity-note]').textContent = notes.join(' ');
    }
    quantity.addEventListener('invalid', () => {
      quantity.setAttribute('aria-invalid', 'true');
      $('[data-shade-quantity-note]').textContent = quantity.validationMessage || 'Check the quantity for this shade.';
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !current.available) return;
      if (!validQuantity(quantity.value, current.quantity_rule)) {
        quantity.setAttribute('aria-invalid', 'true');
        $('[data-shade-quantity-note]').textContent = 'Choose a whole-number quantity within the displayed limits.';
        quantity.focus();
        return;
      }
      const checkout=event.submitter?.hasAttribute('data-standard-checkout') || false;
      const selectedId = String(current.id);
      const selectedQuantity = Number(quantity.value);
      busy = true;
      add.disabled = true;
      $('[data-standard-checkout]').disabled=true;
      add.textContent = 'Adding…';
      selectors.concat(dimensionSelects,colorControls).forEach(select => { select.disabled = true; });
      quantity.disabled = true;
      form.setAttribute('aria-busy', 'true');
      setError('');
      try {
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: selectedId, quantity: selectedQuantity }], sections: ['cart-drawer','cart-icon-bubble'], sections_url:location.pathname })
        });
        let payload;
        try { payload = await response.json(); } catch (_) { throw new Error('Could not confirm this addition. Review your bag before trying again.'); }
        if (!response.ok) {
          const reason = payload.description || payload.message;
          throw new Error(typeof reason === 'string' ? reason : 'This item could not be added. Review your selection and bag before trying again.');
        }
        global.OnaStandardProduct.finishCart(payload,checkout,base,add);
        busy=false;selectors.concat(dimensionSelects,colorControls).forEach(select=>{select.disabled=false;});quantity.disabled=false;form.removeAttribute('aria-busy');add.disabled=!current.available;$('[data-standard-checkout]').disabled=!current.available;add.textContent=current.available?addLabel:'Currently sold out';
      } catch (error) {
        setError(error.message || 'Could not confirm this addition. Review your bag before trying again.');
        busy = false;
        selectors.concat(dimensionSelects,colorControls).forEach(select => { select.disabled = false; });
        quantity.disabled = false;
        form.removeAttribute('aria-busy');
        add.disabled = !current.available;
        $('[data-standard-checkout]').disabled=!current.available;
        add.textContent = current.available ? addLabel : 'Currently sold out';
      }
    });
    global.addEventListener('popstate', () => {
      if (!root.isConnected || busy) return;
      const id = new URL(global.location.href).searchParams.get('variant');
      display(variants.find(variant => String(variant.id) === id) || variants.find(variant => variant.available) || variants[0], false);
    });
    display(current, false);
    $('[data-shade-fallback]').hidden = true;
    $('[data-shade-picker]').hidden = selectors.length === 0;
  }

  function mount(scope) {
    scope.querySelectorAll('[data-ona-shade]').forEach(initialize);
  }
  api.mount = mount;
  global.OnaShadeUI = api;
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})(typeof window === 'object' ? window : globalThis);
